'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DisplayValue = undefined;

var _templateObject = _taggedTemplateLiteral(['\n    font-family: \'Poppins\', sans-serif;\n    width: 100%;\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n'], ['\n    font-family: \'Poppins\', sans-serif;\n    width: 100%;\n    ', ';\n    ', ';\n    ', ';\n    ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: ', 'px;\n  color: ', ';\n  max-width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-bottom: none;\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: ', 'px;\n  color: ', ';\n  max-width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-bottom: none;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: flex;\n  align-items: ', ';\n  justify-content: center;\n  font-size: ', 'px;\n  white-space: nowrap;\n  ', ';\n  color: ', ';\n  height: ', ';\n  width: 100%;\n  overflow: hidden;\n  padding: 0 1rem;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  ', ';\n  ', ';\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  align-items: ', ';\n  justify-content: center;\n  font-size: ', 'px;\n  white-space: nowrap;\n  ', ';\n  color: ', ';\n  height: ', ';\n  width: 100%;\n  overflow: hidden;\n  padding: 0 1rem;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  ', ';\n  ', ';\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  font-size: ', 'px;\n  color: ', ';\n  width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  border-radius: 0 0 10px 10px;\n'], ['\n  box-sizing: border-box;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  font-size: ', 'px;\n  color: ', ';\n  width: 100%;\n  height: ', 'px;\n  background-color: ', ';\n  border: 1px solid ', ';\n  border-top: none;\n  border-radius: 0 0 10px 10px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _colors = require('../../constants/colors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DisplayContainer = _styledComponents2.default.div(_templateObject, function (props) {
  return props.top && 'margin-top: ' + (0, _getSize2.default)(props.top) + 'px;';
}, function (props) {
  return props.bottom && 'margin-bottom: ' + (0, _getSize2.default)(props.bottom) + 'px;';
}, function (props) {
  return props.left && 'margin-left: ' + (0, _getSize2.default)(props.left) + 'px;';
}, function (props) {
  return props.right && 'margin-right: ' + (0, _getSize2.default)(props.right) + 'px;';
});

var Header = _styledComponents2.default.div(_templateObject2, function (props) {
  return props.isMobile ? 12 : 18;
}, function (props) {
  switch (props.mode) {
    case 'accent':
    case 'regular':
    case 'warning':
    case 'success':
    case 'error':
      return 'white';
    case 'light':
    default:
      return _colors.Colors.PrimaryText;
  }
}, function (props) {
  return props.isMobile ? 22 : 45;
}, function (props) {
  switch (props.mode) {
    case 'light':
      return _colors.Colors.StrokeLight;
    case 'accent':
      return _colors.Colors.Primary;
    case 'error':
      return _colors.Colors.Error;
    case 'warning':
      return _colors.Colors.Warning;
    case 'success':
      return _colors.Colors.Success;
    case 'regular':
    default:
      return _colors.Colors.StrokeVeryDark;
  }
}, _colors.Colors.StrokeLight);

var Value = _styledComponents2.default.div(_templateObject3, function (props) {
  return props.isDescription ? 'flex-end' : 'center';
}, function (props) {
  return props.isMobile ? 30 : 75;
}, function (props) {
  return props.isDescription && 'line-height: 1;';
}, function (props) {
  switch (props.mode) {
    case 'accent':
      return _colors.Colors.Primary;
    case 'error':
      return _colors.Colors.Error;
    case 'warning':
      return _colors.Colors.Warning;
    case 'success':
      return _colors.Colors.Success;
    case 'regular':
    case 'light':
    default:
      return _colors.Colors.PrimaryText;
  }
}, function (props) {
  if (props.isMobile && props.isDescription) {
    return '51px';
  } else if (props.isMobile && !props.isDescription) {
    return '73px';
  } else if (!props.isMobile && props.isDescription) {
    return '110px';
  } else {
    return '155px';
  }
}, _colors.Colors.LightMode, _colors.Colors.StrokeLight, function (props) {
  return props.isDescription && 'border-bottom: none;';
}, function (props) {
  return !props.isDescription && 'border-radius: 0 0 10px 10px;';
});

var Description = _styledComponents2.default.div(_templateObject4, function (props) {
  return props.isMobile ? 12 : 16;
}, _colors.Colors.StrokeDark, function (props) {
  return props.isMobile ? 22 : 45;
}, _colors.Colors.LightMode, _colors.Colors.StrokeLight);

var DisplayValue = exports.DisplayValue = function DisplayValue(_ref) {
  var header = _ref.header,
      value = _ref.value,
      description = _ref.description,
      _ref$mode = _ref.mode,
      mode = _ref$mode === undefined ? 'regular' : _ref$mode,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right;

  var valueRef = (0, _react.useRef)(null);

  var isMobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());
  var isDescription = description && description.trim().length > 0;

  var adjustFontSize = function adjustFontSize() {
    if (!valueRef.current) return;

    var element = valueRef.current;
    var computedStyle = window.getComputedStyle(element);
    var fontSize = parseFloat(computedStyle.fontSize);

    while (element.scrollWidth > element.clientWidth && fontSize > 10) {
      fontSize -= 1;
      element.style.fontSize = fontSize + 'px';
    }
  };

  (0, _react.useEffect)(function () {
    adjustFontSize();
  }, [value]);

  return _react2.default.createElement(
    DisplayContainer,
    { top: top, bottom: bottom, left: left, right: right },
    _react2.default.createElement(
      Header,
      { mode: mode, isMobile: isMobile },
      header
    ),
    _react2.default.createElement(
      Value,
      { ref: valueRef, isDescription: isDescription, mode: mode, isMobile: isMobile },
      value
    ),
    isDescription && _react2.default.createElement(
      Description,
      { isMobile: isMobile },
      description
    )
  );
};

exports.default = DisplayValue;


DisplayValue.propTypes = {
  header: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  description: _propTypes2.default.string,
  mode: _propTypes2.default.oneOf(['regular', 'accent', 'warning', 'error', 'success', 'light']),
  top: _propTypes2.default.number,
  bottom: _propTypes2.default.number,
  left: _propTypes2.default.number,
  right: _propTypes2.default.number
};